module.exports = __webpack_public_path__ + "img/Save-time-with-Dashboard.80f02dd0.png";